import React, { useState } from 'react';
import { NameDescriptionFields, PlanTitle, ProductSelectField } from './sharedFields';

const DetailsStep = (props) => {
  const [errors, setErrors] = useState({});

  return (
    <div className="wizard-forms-wrapper p-grid p-nogutter">
      <div className="col-12 wizard-forms">
        <PlanTitle t={props.t} tierExist={props.tierExist} />
        <p className="first_hr" />
        <NameDescriptionFields
          formik={props.formik}
          t={props.t}
          isFormFieldValid={props.isFormFieldValid}
          getFormErrorMessage={props.getFormErrorMessage}
          errors={errors}
          setErrors={setErrors}
        />
        {!props.planGroupExist && props.planGroups?.length > 1 && (
          <ProductSelectField
            formik={props.formik}
            t={props.t}
            planGroups={props.planGroups}
            isFormFieldValid={props.isFormFieldValidPlanId}
            getFormErrorMessagePlanId={props.getFormErrorMessagePlanId}
            onChangePlanGroup={props.onChangePlanGroup}
          />
        )}
      </div>
    </div>
  );
};

export default DetailsStep;
